<template>
    <div class="access-denied error-wrapper">
        <div class="error-part">
            <div class="logo">
                <img v-if="appLogo" :src="appLogo" :alt="project" class="logo-smart">
                <span v-else>{{ project }}</span>
            </div>
            <div class="title-wrap">
                <h1 class="main-title">401 </h1>
                <h2 class="main-sub-title">Access Denied</h2>
                <div class="form-group">
                    <a href="/public" class="btn btn-primary">Go Home</a>
                    <a href="/logout" class="btn btn-primary">Logout</a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "PageAccessDenied",
    data: () => ({
        project: import.meta.env.VITE_APP_NAME,
        appType: import.meta.env.VITE_APP_TYPE,
        appLogo: import.meta.env.VITE_APP_LOGO_HEADER,
    }),
}
</script>

<style lang="scss" scoped>
    .access-denied {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(144.89deg, #fff 2.83%, #ed6b75 100%);
        z-index: 99999999;
        .h1 {
            font-size: 70px;
        }
        .denied {
            font-size: 25px;
        }
        .error-part {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            .logo-smart {
                margin: 0;
            }
            .main-title {
                font-size: 70px;
            }
            .btn {
                margin-top: 20px;
            }
        }

    }
</style>
